import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// components
import LogIn from 'layouts/authentication/sign-in/basic';
import { useAuthContext } from './useAuthContext';

// ----------------------------------------------------------------------


export default function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized } = useAuthContext();

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState(null);


  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <LogIn />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <> {children} </>;
}